<template>
  <v-toolbar dark elevation="0" color="primary">
    <v-container>
      <v-toolbar-title> Register device </v-toolbar-title>
    </v-container>

    <template v-slot:extension>
      <!-- <v-container class="caption primary--text"> -->
      <v-container class="text-body-2 text-md-body-1 text-lg-body-1 text-xl-body-1">
        Registration of new devices
      </v-container>
    </template>
  </v-toolbar>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";
</style>
